var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadsSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1517 11.2493L7.5 13.901L4.84835 11.2493",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.8125V7.8125",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37125 9.37461H11.25C11.913 9.37461 12.5489 9.11122 13.0178 8.64238C13.4866 8.17353 13.75 7.53765 13.75 6.87461C13.75 6.21157 13.4866 5.57568 13.0178 5.10684C12.5489 4.638 11.913 4.37461 11.25 4.37461C11.25 4.01568 11.147 3.66429 10.9532 3.36218C10.7595 3.06006 10.483 2.81991 10.1568 2.67025C9.83057 2.52059 9.46824 2.46771 9.11284 2.5179C8.75744 2.56808 8.42392 2.71922 8.15188 2.95336C7.74076 2.42748 7.15602 2.06496 6.50217 1.93061C5.84833 1.79626 5.16801 1.89884 4.58286 2.22001C3.9977 2.54118 3.54584 3.06001 3.30808 3.68373C3.07031 4.30745 3.06213 4.99541 3.285 5.62461H3.125C2.62772 5.62461 2.15081 5.82215 1.79917 6.17378C1.44754 6.52541 1.25 7.00233 1.25 7.49961C1.25 7.99689 1.44754 8.4738 1.79917 8.82543C2.15081 9.17706 2.62772 9.37461 3.125 9.37461H5.30875",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadsSvgrepoCom1);
export default __webpack_public_path__ + "static/media/downloads-svgrepo-com 1.f1c01c7cdd30baeb53666f3005fc4c05.svg";
export { ForwardRef as ReactComponent };